import { render, staticRenderFns } from "./DetailRow.vue?vue&type=template&id=37f5ee41&scoped=true"
import script from "./DetailRow.vue?vue&type=script&lang=js"
export * from "./DetailRow.vue?vue&type=script&lang=js"
import style0 from "./DetailRow.vue?vue&type=style&index=0&id=37f5ee41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f5ee41",
  null
  
)

export default component.exports